import React from 'react'
import { Link } from 'react-router-dom'
import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import sanitizeHtml from 'sanitize-html'
import useCsrfToken from '../hooks/useCsrfToken';

Paquetesmini.propTypes = {
    listingid: PropTypes.string,
};

export default function Paquetesmini({ listingid }) {
    const { csrfToken } = useCsrfToken();
    const [listings, setListings] = useState([]);
    useEffect(() => {
        const API_URL = process.env.REACT_APP_API_URL;
        const stripTagsFromHtml = (html) => {
            const allowedTags = ['b', 'u', 'i', 'p', 'br', 'span', 'strong', 'em', 'a'];
            return sanitizeHtml(html, {
                allowedTags: allowedTags
            });
        };
        const transformData = (data) => {
            return {
                id: data.id,
                image: `${API_URL}${data.primary_image}`,
                tag: 'Paquetes',
                name: data.title,
                slug: data.slug,
                intro: data.intro !== '' ? stripTagsFromHtml(data.intro) : '',
                desc: data.description.length > 100 ? stripTagsFromHtml(data.description).substring(0, 100) + '...' : stripTagsFromHtml(data.description),
                tags: data.tags,
                gallery: data.gallery?.gallerythumbs,
                gallerylarge: data.gallery?.galleryimages,
                brochure_url: data.brochure_url,
                cta_url: data.cta_url,
                phone_1: data.phone_1,
                title: data.title,
                listing_type: data.listing_type,
                embed: data.embed,
                cta_icon: data.cta_icon
            };
        };
        if (!listingid) return;
        if (csrfToken != null) {
            fetch(`${API_URL}/api/packages-by-tag/${listingid}`, {
                method: 'GET',
                credentials: 'include',
                headers: {
                    'X-CSRF-TOKEN': csrfToken,
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                }
            }).then(response => response.json())
                .then(data => {
                    if (data.length && !data.error) {
                        const transformedListings = data.map(item => transformData(item));
                        setListings(transformedListings);
                    }

                })
                .catch(error => console.error('Error fetching data:', error));
        }
    }, [listingid, csrfToken]);
    return (
        <>
            {listings && listings.length > 0 && (
                <div className="row">
                    <div className="mt-4 pt-2">
                        <h6 className="pt-2 pb-2 bg-light rounded text-center">Productos relacionados</h6>
                        <div className="mt-4">
                            {listings.map((item, index) => {
                                return (
                                    <div className="blog blog-primary d-flex align-items-center mt-3" key={index}>
                                        <Link to={`/paquete/${item.slug}`}>
                                            <img src={item.image} className="avatar avatar-small rounded object-fit-cover" style={{ width: 'auto' }} alt={item.title} />
                                        </Link>
                                        <div className="flex-1 ms-3">
                                            <Link to={`/paquete/${item.slug}`} className="d-block title text-dark fw-medium">{item.title}</Link>
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                </div>
            )}
        </>
    )
}
